export { default as SearchResultCard } from './search-result-card';
export type { SearchResultCardProps } from './search-result-card';
